import ApiBudgety from '@/api/apiBudgety'

export const notaProyectoService = {
  getNotaProyectoByIdProyecto,
  guardarNotaProyecto,
}

async function getNotaProyectoByIdProyecto(id) {
  return await ApiBudgety.get('NotaProyecto/FindAllByIdProyectoAsync/' + id)
}

async function guardarNotaProyecto(body) {
  return await ApiBudgety.post('NotaProyecto/InsertOrUpdate/', body)
}
